import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function useNotification() {

  const notify = (message, options = {}) => {
    const { type, ...restOptions } = options;

    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        ...restOptions,
      });
    } else if (type === 'error') {
      toast.error(message, {
        position: 'bottom-right',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        ...restOptions,
      });
    }else if (type === 'alert') {
      toast.alert(message, {
        position: 'bottom-right',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        ...restOptions,
      });
    }  else if (type === 'fast') {
      toast.success(message, {
        position: 'bottom-right',
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        ...restOptions,
      });
    } else {
      toast.info(message, {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        ...restOptions,
      });
    }
  };

  return {
    notify,
  };
}
